import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { SiteLayout } from './components/layout/SiteLayout';
import { Home } from './pages/Home';
import { Candidate } from './pages/Candidate';
import { Vision } from './pages/Vision';
import { Agenda } from './pages/Agenda';
import { PolicyDetail } from './pages/PolicyDetail';
import { FirstHundredDays } from './pages/FirstHundredDays';
import { TrackRecord } from './pages/TrackRecord';
import { Manifesto } from './pages/Manifesto';
import { Nigeria } from './pages/Nigeria';
import { RegionDetail } from './pages/RegionDetail';
import { News } from './pages/News';
import { NewsArticle } from './pages/NewsArticle';
import { Events } from './pages/Events';
import { EventDetail } from './pages/EventDetail';
import { Join } from './pages/Join';
import { VolunteerApply } from './pages/VolunteerApply';
import { Support } from './pages/Support';
import { Media } from './pages/Media';
import { Facts } from './pages/Facts';
import { FactDetail } from './pages/FactDetail';
import { Resources } from './pages/Resources';
import { Contact } from './pages/Contact';
import { Faq } from './pages/Faq';
import { Search } from './pages/Search';
import { Live } from './pages/Live';
import { NotFound } from './pages/NotFound';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
const pages: {
  path: string;
  element: React.ReactNode;
}[] = [{
  path: '/candidate',
  element: <Candidate data-id="element-0" data-mp="33ngfk3w8qtzg" />
}, {
  path: '/vision',
  element: <Vision data-id="element-1" data-mp="38lro8basuyg3" />
}, {
  path: '/agenda',
  element: <Agenda data-id="element-2" data-mp="38kqau06b9zv7" />
}, {
  path: '/agenda/:slug',
  element: <PolicyDetail data-id="element-3" data-mp="38o4f5dyjcj5a" />
}, {
  path: '/first-100-days',
  element: <FirstHundredDays data-id="element-4" data-mp="3dlns8ajhypvn" />
}, {
  path: '/track-record',
  element: <TrackRecord data-id="element-5" data-mp="nvstx4mognvy" />
}, {
  path: '/manifesto',
  element: <Manifesto data-id="element-6" data-mp="nv0x5qhcgk43" />
}, {
  path: '/nigeria',
  element: <Nigeria data-id="element-7" data-mp="sudmqizlo5ad" />
}, {
  path: '/nigeria/:region',
  element: <RegionDetail data-id="element-8" data-mp="st2k4mhw53ku" />
}, {
  path: '/news',
  element: <News data-id="element-9" data-mp="3686fj9n0kvj" />
}, {
  path: '/news/:slug',
  element: <NewsArticle data-id="element-10" data-mp="34x0pdwmt31s" />
}, {
  path: '/events',
  element: <Events data-id="element-11" data-mp="3ud1glcmeruc7" />
}, {
  path: '/events/:slug',
  element: <EventDetail data-id="element-12" data-mp="3uc9jtyh2rqkc" />
}, {
  path: '/join',
  element: <Join data-id="element-13" data-mp="d4o09u01u88q" />
}, {
  path: '/join/apply',
  element: <VolunteerApply data-id="element-14" data-mp="d3cw3t2oyyh3" />
}, {
  path: '/support',
  element: <Support data-id="element-15" data-mp="85l0anyxes7m" />
}, {
  path: '/media',
  element: <Media data-id="element-16" data-mp="86w7kxrkyi3h" />
}, {
  path: '/facts',
  element: <Facts data-id="element-17" data-mp="83qihiiybg7r" />
}, {
  path: '/facts/:slug',
  element: <FactDetail data-id="element-18" data-mp="3gmfwxlp4rgd9" />
}, {
  path: '/resources',
  element: <Resources data-id="element-19" data-mp="3gj1s86szuv2n" />
}, {
  path: '/contact',
  element: <Contact data-id="element-20" data-mp="3bncpxvplb02n" />
}, {
  path: '/faq',
  element: <Faq data-id="element-21" data-mp="3bk70uggyny6x" />
}, {
  path: '/search',
  element: <Search data-id="element-22" data-mp="3qbppt3rst32f" />
}, {
  path: '/live',
  element: <Live data-id="element-23" data-mp="3qcqzb3t61hi1" />
}, {
  path: '*',
  element: <NotFound data-id="element-24" data-mp="3lkhdnzz333lk" />
}];
export function App() {
  return <BrowserRouter data-id="element-25" data-mp="3liwjibgolmo8">
      <ScrollToTop data-id="element-26" data-mp="3liedin47vu34" />
      <Routes data-id="element-27" data-mp="2xuwsrbjddw9n">
        <Route path="/" element={<Home data-id="element-29" data-mp="2xtv8cgggrxf9" />} data-id="element-28" data-mp="2xudatutpz7vm" />
        {pages.map(page => <Route key={page.path} path={page.path} element={<SiteLayout data-id="element-31" data-mp="2stpkzch88x2z">{page.element}</SiteLayout>} data-id="element-30" data-mp="2svtnpr3e3q1o" />)}
      </Routes>
    </BrowserRouter>;
}